import { Fragment } from "react";

const ReviewPracticalExamQuestion = ({ input, index, selectedIndex }) => {
    const storyBoardTitle = input && input.storyBoardTitle;
    const storyBoardInfo = input && input.storyBoardInfo;
    const taskTitle = input && input.taskTitle;
    const taskInfo = input && input.taskInfo;
    let answer = (input && input.answer) ?? "<b>[Empty]</b>";
    if (answer === undefined || answer === null || answer === '') {
        answer = "<center>[Empty]</center>";
    }
    return (
        <Fragment>
            <hr />
            <div className="d-flex flex-column pb-2">
                <label className=" pb-2" style={{ color: '#0F75BC' }}>{storyBoardTitle}</label>
                <div>{storyBoardInfo}</div>
            </div>
            <hr />
            <div className="d-flex flex-column pb-2">
                <label className=" pb-2" style={{ color: '#0F75BC' }}>{taskTitle}</label>
                <div>{taskInfo}</div>
            </div>
            <hr />
            <div className="d-flex flex-column pb-2">
                <label className="pb-2" style={{ color: '#0F75BC' }}>Answer</label>
                <div className="border" dangerouslySetInnerHTML={{ __html: answer }}></div>
            </div>
            <hr />
        </Fragment>
    );
};

export default ReviewPracticalExamQuestion;
